import { type ComponentProps, lazy, Suspense } from 'react';

import type { MapView as MapViewComponent } from './MapView';

// Leaflet wird erst geladen, wenn eine Karte angezeigt wird (kleineres Start-Bundle).
const MapViewLazy = lazy(() => import('./MapView').then((m) => ({ default: m.MapView })));

export function LazyMapView(props: ComponentProps<typeof MapViewComponent>) {
  return (
    <Suspense fallback={<div className={props.className ? `map-view ${props.className}` : 'map-view'} aria-busy="true" />}>
      <MapViewLazy {...props} />
    </Suspense>
  );
}
